'use strict';


import { BaseElement } from '../interfaces/BaseElement';
import gsap from 'gsap';
import { GSAPAnimationMixer, isMobile } from '../../settings';
import { getUrlParam } from '../../functions';
import { Cloudflare } from '../api/Cloudflare';
import { changeLangToCurrent } from './langSwitcher/langSwitcher';
import { BmbyMode } from '../mode/BmbyMode';

export class PWA {
	static icon = `${config.cdnRepository}/resize/image/width=60,height=50/${config.projectFolder}/resources/img/favicon.png?v=${Cloudflare.version}`

	constructor () {
		this.event = null;
		this.container = null;
		this.icon = PWA.icon;
	}

	addEvents () {
		if (window.BeforeInstallPromptEvent) {
			window.addEventListener('beforeinstallprompt', (e) => {
				e.preventDefault();
				this.event = e;
			});
		}
	}

	#animate (state) {
		if (state === 'show') {
			return new Promise(resolve => {
				gsap.fromTo(this.container, {
					y: '-200%',
				}, {
					y: 0,
					duration: 1,
					ease: GSAPAnimationMixer.ease,
					onComplete: () => resolve(),
				});
			});
		} else {
			return new Promise(resolve => {
				gsap.to(this.container, {
					y: '-200%',
					duration: 1,
					ease: GSAPAnimationMixer.ease,
					onComplete: () => resolve(),
				});
			});
		}
	}

	async show () {
		if (getUrlParam('source') === 'pwa' || !isMobile || BmbyMode.active) return;

		await new Promise(resolve => {
			const interval = setInterval(() => {
				const videoPopUp = document.querySelector('.video-pop-up');
				const consolto = document.querySelector('.drop-down__clone');
				const notify = document.querySelector('.notiflix-notify');
				if (!videoPopUp && !consolto && !notify) {
					clearInterval(interval);
					resolve();
				}
			},200)
		});

		this.container = new BaseElement()
			.addClass('pwa')
			.appendTo(document.body)
			.DOMElement;

		const wrapper = new BaseElement()
			.addClass('pwa__wrapper')
			.appendTo(this.container)
			.DOMElement;

		const logo = new BaseElement()
			.addClass('pwa__logo')
			.appendTo(wrapper)
			.DOMElement;

		new BaseElement('img')
			.addClass('pwa__icon')
			.addAttribute('src', this.icon)
			.appendTo(logo);

		const contentBlock = new BaseElement()
			.addClass('pwa__content-block')
			.appendTo(wrapper)
			.DOMElement;

		const textBlock = new BaseElement()
			.addClass('pwa__text-block')
			.appendTo(contentBlock)
			.DOMElement;

		new BaseElement('span')
			.addClass('pwa__title', 'language-string')
			.addAttribute('data-dictionary', 'Install the application')
			.innerHtml(changeLangToCurrent('Install the application'))
			.appendTo(textBlock);

		new BaseElement('span')
			.addClass('pwa__title')
			.innerHtml(`"${config.projectTitle}"`)
			.appendTo(textBlock);

		new BaseElement('button')
			.addClass('pwa__install', 'language-string')
			.addAttribute('data-dictionary', 'Install')
			.innerHtml(changeLangToCurrent('Install'))
			.appendTo(contentBlock)
			.event('click', this.#installHandler.bind(this));

		new BaseElement()
			.addClass('pwa__close-btn', 'icon-close')
			.appendTo(contentBlock)
			.event('click', this.close.bind(this));

		this.#animate('show');
	}

	async #installHandler () {
		if (this.event) {
			this.event.prompt();
			// const {outcome} = await this.event.userChoice;
			// if (outcome === 'accepted') {
			//
			// } else if (outcome === 'dismissed') {
			//
			// }
			this.event = null;
		} else {
			const installHelper = new window.AddToHomeScreen(
				{
					appName: config.projectTitle,
					appIconUrl: this.icon,
					assetUrl: './img/pwa/',
					showErrorMessageForUnsupportedBrowsers: window.AddToHomeScreen.SHOW_ERRMSG_UNSUPPORTED.NONE,
					allowUserToCloseModal: false,
					maxModalDisplayCount: -1,
				});
			installHelper.show();

			const container = document.querySelector('.adhs-container');

			if (container) {
				const modal = container.querySelector('.adhs-modal');
				new BaseElement('button')
					.addClass('button','pwa__close-modal-btn')
					.innerHtml('Close')
					.event('click',() => container.remove())
					.appendTo(modal);
			}
		}
		this.close();
	}

	async close () {
		await this.#animate('hide');
		this.container.remove();
	}

}


// document.addEventListener('DOMContentLoaded', function () {
// 	window.AddToHomeScreenInstance = new window.AddToHomeScreen({
// 		appName: config.projectTitle,
// 		appIconUrl: 'https://dreamsimages.bmby.com/resize/image/width=256/GreenSide/resources/img/logo.png',
// 		assetUrl: './img/pwa/',
// 		showErrorMessageForUnsupportedBrowsers: window.AddToHomeScreen.SHOW_ERRMSG_UNSUPPORTED.NONE,
// 		allowUserToCloseModal: false,
// 		maxModalDisplayCount: -1
// 	});
//
// 	const popup = window.AddToHomeScreenInstance.show('en');
// });
